export function columnTheme() {
  return {
    '&:nth-child(0)': {
      width: '45px',
    },
    '&:nth-child(1)': {
      minWidth: '40px',
      maxWidth: '40px',
    },
    '&:nth-child(2)': {
      minWidth: '75px',
      maxWidth: '75px',
    },
    '&:nth-child(3)': {
      minWidth: '75px',
      maxWidth: '75px',
    },
    '&:nth-child(4)': {
      maxWidth: '95px',
      minWidth: '95px',
    },
    '&:nth-child(5)': {
      minWidth: '75px',
      maxWidth: '75px',
    },
    '&:nth-child(6)': {
      minWidth: '300px',
      maxWidth: '400px',
    },
    '&:nth-child(7)': {
      minWidth: '100px',
      maxWidth: '120px',
    },
    '&:nth-child(8)': {
      maxWidth: '95px',
      minWidth: '95px',
    },
    '&:nth-child(9)': {
      minWidth: '150px',
      maxWidth: '280px',
    },
    '&:nth-child(10)': {
      minWidth: '150px',
      maxWidth: '280px',
    },
    '&:nth-child(11)': {
      minWidth: '150px',
      maxWidth: '280px',
    },
    '&:nth-child(12)': {
      width: '50px',
    },
  }
}
